<ng-container *ngIf="productBadge.tooltip">
  <ng-container *ngTemplateOutlet="withPopup"></ng-container>
</ng-container>

<ng-container *ngIf="!productBadge.tooltip">
  <ng-container *ngTemplateOutlet="withoutPopup"></ng-container>
</ng-container>

<ng-template #withPopup>
  <span [style]="css" suiPopup [popupInverted] [popupText]="productBadge.tooltip" popupPlacement="top">{{
    productBadge.name
  }}</span>
</ng-template>
<ng-template #withoutPopup>
  <span [style]="css">{{ productBadge.name }}</span>
</ng-template>

<ng-template #tooltip>
  <div class="tooltip">
    {{ productBadge.tooltip }}
  </div>
</ng-template>
